import { Skeleton } from "@/components/ui/skeleton";

export default function GanttChartLoading() {
  return (
    <div className="aero:w-full aero:space-y-6 aero:mt-4">
      {/* Gatt Chart Toolbar */}
      <div className="aero:flex aero:gap-10">
        <Skeleton className="aero:h-10 aero:w-20 aero:flex-none" />
        <Skeleton className="aero:h-10 aero:grow" />
        <Skeleton className="aero:h-10 aero:w-20 aero:flex-none" />
      </div>
      {/* Gantt Chart Content */}
      <Skeleton className="aero:h-screen aero:w-full" />
    </div>
  );
}
